import { type RouteRecordRaw } from 'vue-router'

export const brandReportingV2Routes: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/SalesSummaryReport.vue'),
        meta: {
          title: 'reports-v2.salesSummaryReport',
        },
        name: `brand.reports-v2.sales`,
        path: 'sales-summary',
      },
      {
        component: async () => import('../views/PaymentMethodsReport.vue'),
        meta: {
          title: 'reports-v2.paymentMethodsReport',
        },
        name: `brand.reports-v2.paymentMethods`,
        path: 'payment-methods',
      },
      {
        component: async () => import('../views/PayoutStatsReport.vue'),
        meta: {
          title: 'reports-v2.payoutsStatsReport',
        },
        name: `brand.reports-v2.payoutsStats`,
        path: 'payout-stats',
      },
      {
        component: async () => import('../views/PayoutDetailPage.vue'),
        meta: {
          title: 'reports-v2.payoutsDetail',
        },
        name: `brand.reports-v2.payouts.detail`,
        path: 'payouts/:payoutId',
        props: true,
      },
      {
        component: async () => import('../views/TipsReport.vue'),
        meta: {
          title: 'reports-v2.tipsReport',
        },
        name: `brand.reports-v2.tips`,
        path: 'tips',
      },
      {
        component: async () => import('../views/FeesReport.vue'),
        meta: {
          title: 'reports-v2.feesReport',
        },
        name: `brand.reports-v2.fees`,
        path: 'fees',
      },
    ],
    path: 'reports-v2',
    redirect: { name: `brand.reports-v2.sales` }, // change to base list when ready
  },
]

// Remove location routes - everything goes through brand routes now with locationId as query param
export const locationReportingV2Routes: RouteRecordRaw[] = []
